<template>
    <div class="wrap">
         <Header></Header>
        <div class="p-card">
             <van-swipe class="pro-hd-pic-1" v-if="tabIndex==3" :autoplay="3000" indicator-color="white">
                <van-swipe-item :key="item.id" v-for="item in building_info.real_picture"><img  :src="downPath+item" alt=""></van-swipe-item>
            </van-swipe>
            <van-swipe class="pro-hd-pic-1" v-if="tabIndex==2" :autoplay="3000" indicator-color="white">
                <van-swipe-item :key="item.id" v-for="item in building_info.effect_picture"><img  :src="downPath+item" alt=""></van-swipe-item>
            </van-swipe>
            <van-swipe class="pro-hd-pic-1" v-if="tabIndex==1" :autoplay="3000" indicator-color="white">
                <van-swipe-item @click="shoview('project_picture')" :key="item.id" v-for="item in building_info.project_picture"><img  :src="downPath+item" alt=""></van-swipe-item>
            </van-swipe>
            <!-- <img  class="main-img" v-if="building_info.main_img&&tabIndex==1" :src="building_info.main_img" alt=""> -->
            <div class="vr-p" @click="entervr"  v-if="tabIndex==1">
                <img src="./vr360.png" alt="">
            </div>
        </div>
        <div class="inner-wrap">
            <div class="main-content">
                <div class="btn-groups">
                    <div @click="markActive(1)" class="item" :class="{'active':tabIndex==1}">VR</div>
                    <div @click="markActive(2)" class="item" :class="{'active':tabIndex==2}">效果图</div>
                    <div @click="markActive(3)" class="item" :class="{'active':tabIndex==3}">实景图</div>
                    <div class="total" v-if="efflen">共{{tabIndex==2?efflen:reallen}}张</div>
                </div>
                <div class="main-wrap">
                   <div class="h-title">
                        <h1>{{building_info.building_name}}</h1>
                        <div class="status" v-show="building_info.rent_sale_formal">{{building_info.rent_sale_formal}}</div>
                   </div>
                    <div style="background:#fff">
                        <div class="btns-wrap">
                            <div class="new-n" v-if="building_info.labels[0]">
                                {{building_info.labels[0].label}}
                            </div>
                            <div class="zhineng" v-if="building_info.labels[1]">
                                {{building_info.labels[1].label}}
                            </div>
                        
                            <div class="shuzimeiti" v-if="building_info.labels[2]">
                                {{building_info.labels[2].label}}
                            </div>
                            <div class="high-jishu" v-if="building_info.labels[3]">
                                {{building_info.labels[3].label}}
                            </div>
                        </div>
                    </div>
                    <ul class="itemdesc-wrap">
                       <li class="price-wrap">
                           <div class="label price">租售价格</div>
                            <div class="content"><span class="big">{{building_info.rent_sale_price}}</span><span class="danwei">{{building_info.rent_sale_price_danwei}}</span></div>
                        </li> 
                        <li>
                            <div class="label">
                                楼盘位置
                            </div>
                            <div class="content" style="color:#2f6095">
                                {{building_info.address}}
                            </div>
                        </li>
                        <li>
                            <div class="label">地铁线路</div>
                            <div class="content">{{building_info.subway_steps}}</div>
                        </li>
                        <li v-if="building_info.features">
                            <div class="label">项目特色</div>
                            <div class="content">{{building_info.features}}</div>
                        </li>
                        <li>
                            <div class="label">开发商</div>
                            <div class="content">{{building_info.development_co}}</div>
                        </li>
                    </ul>
                    <div @click="housedesc" class="more-btn">
                        <div class="inner">更多信息</div>
                    </div>
                     <div class="clicks-btn">
                       <div class="inner">
                            <!-- <div class="view">
                                
                    <span v-if="companyInfo.isfocus == 0" @click="addFocus">关注</span>
                    <span v-else-if="companyInfo.isfocus == 1" @click="delFocus">已关注</span>
                            </div> -->
                            <div v-if="building_info.iscollect==0" class="store" @click="keepHouse">收藏</div>
                            <div  class="store" v-if="building_info.iscollect==1">已收藏</div>
                            <div class="share" @click="showTip = true">分享</div>
                            <div class="show">考察楼盘</div>
                       </div>
                    </div>
                    <div class="user-wrap" v-if="developer">
                        <div class="left">
                            <div>拨打电话免费咨询</div>
                            <div class="big-phone">{{developer.contact_call_400}}</div>
                        </div>
                        <div class="right">
                            <div class="inner-left">
                                <img :src="downPath+developer.avatar" alt="">
                            </div>
                            <div class="inner-right">
                                <div>
                                    <span class="name">{{developer.nickname}}</span>
                                    <span class="job">选址顾问</span>
                                </div>
                                <div class="company_name">
                                    {{developer.company_name}}
                                </div>
                                <div  @click="keepHouse" v-if="building_info.iscollect==0" class="introduence">
                                    关注
                                </div>
                                <div   v-if="building_info.iscollect==1" class="introduence">
                                    已关注
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="house-wrap">
                        <div class="title">
                            <div class="left">楼盘详情</div>
                            <div @click="housedesc" class="right"><span>查看更多</span><van-icon name="arrow" /></div>
                        </div>
                        <p class="content" v-html="building_info.description">
                           <!-- {{building_info.description}} -->
                        </p>
                    </div>
                    <div class="house-type">
                        <div class="title">
                            <div class="left">主力户型（{{roomdraw_list.length}}）</div>
                         <!-- <div @click="morehu" class="right"><span>查看更多</span><van-icon name="arrow" /></div> -->
                        </div>
                        <div gutter="80" class="photos" type="flex" justify="space-between">
                            <div class="item" span="8" v-for="item in roomdraw_list" :key="item.id">
                                <div class="inner">
                                     <img @click="shoview('huxing')" :src="downPath+item.draw_url" alt="">
                                </div>
                                <div class="in-title">{{item.custom}}</div>
                                <div class="in-subtitle">建筑面积约{{item.area}}平米</div>
                                <div class="in-status">{{item.room_status==1?'在售':'在租'}}</div>
                            </div>
                        </div>
                    </div>
					
                    <div class="house-source" v-if="building_house_list.length">
                        <div class="title">
                            <div class="left">房源</div>
                            
                            <div @click="entermore('fangyuan')"  class="right"><span>查看更多</span><van-icon name="arrow" /></div>
                        </div>
                    </div>
                    <div class="fang-fang" v-if="building_house_list.length">
                        <div @click="entermore('house',item)" class="fanyuan-wrap" :key="item.id"  v-for="item in building_house_list">
                        <div class="left-img">
                             <img :src="item.url" alt="">
                        </div>
                        <div class="right-desc">
                            <div class="top">
                                <span class="big">{{item.area}}</span>m²
                                <span class="status">
                                   {{item.sales_status}}
                                </span>
                            </div>
                            <div class="center">
                                <span>单价：</span>
                                <span>{{item.rent_sale_price}}元/m²/天</span>
                            </div>
                            <div class="bottom">
                                {{item.labels[0].label}}/ {{item.labels[1].label}}/ {{item.labels[2].label}}
                            </div>
                        </div>
                    </div>
                    </div>
                    <!-- <table v-if="building_house_list.length" style="width:100%;">
                        <tr class="select-wrap" >
                            <td class="all">全部（{{building_house_list.length}}套）</td>
                            <td  class="area" style="text-align:center;">面积</td>
                            <td class="price" style="text-align:center;">单价</td>
                            <td  class="status" style="text-align:center;">状态</td>
                            <td  class="key" style="text-align:center;">特色</td>
                        </tr>
                        <tr  class="select-content" :key="item.id"  v-for="item in building_house_list">
                            <td class="img-wrap"> <img :src="item.url" alt=""></td>
                            <td class="area" style="text-align:center;"> <span style="display:flex">{{item.area}}</span>
                            <span style="display:flex" class="gray">㎡</span></td>
                            <td class="price" style="text-align:center;">  <span>{{item.rent_sale_price}}</span>
                            <span class="gray">{{item.rent_sale_price_danwei}}</span></td>
                            <td  class="status" style="text-align:center;"> {{item.rent_sale_formal==1?'在售':'在租'}}</td>
                            <td class="key" style="text-align:center;"> <div v-if="item.labels[0]" class="item top">{{item.labels[0].label}}</div>
                           <div v-if="item.labels[1]" class="item center">{{item.labels[1].label}}</div>
                           <div v-if="item.labels[2]" class="item bottom">{{item.labels[2].label}}</div></td>
                        </tr>
                    </table> -->
                    <!-- <div class="select-wrap" v-if="building_house_list.length">
                        <div class="all">全部（{{building_house_list.length}}套）</div>
                        <div class="area">面积</div>
                        <div class="price">单价</div>
                        <div  class="status">状态</div>
                        <div  class="key">特色</div>
                    </div> -->
                    <!-- <div v-if="building_house_list.length">
                        <div class="select-content" :key="item.id"  v-for="item in building_house_list">
                        <div class="img-wrap">
                            <img :src="item.url" alt="">
                        </div>
                        <div class="area">
                            <span>{{item.area}}</span>
                            <span class="gray">㎡</span>
                        </div>
                        <div class="price">
                            <span>{{item.rent_sale_price}}</span>
                            <span class="gray">{{item.rent_sale_price_danwei}}</span>
                        </div>
                        <div class="status">
                           {{item.rent_sale_formal==1?'在售':'在租'}}
                        </div>
                        <div class="key">
                           <div v-if="item.labels[0]" class="item top">{{item.labels[0].label}}</div>
                           <div v-if="item.labels[1]" class="item center">{{item.labels[1].label}}</div>
                           <div v-if="item.labels[2]" class="item bottom">{{item.labels[2].label}}</div>
                        </div>
                    </div>
                    </div> -->
                     <div class="traffic-wrap">
                        <div class="title">
                            交通配套
                        </div>
                        <div id="map" class="map">
                            <baidu-map style="height:100%" :center="mapInfo.center" :zoom="mapInfo.zoom">
                                <bm-marker :position="mapInfo.center"></bm-marker>
                                <bm-circle :center="mapInfo.center" :radius="mapInfo.radius"></bm-circle>
                                <bm-local-search :keyword="mapKey" :nearby="mapInfo" :panel="false"></bm-local-search>
                            </baidu-map>
                        </div>
                        <div class="photos">
                            <div class="item">
                                <div class="top">
                                    <img src="./gongjiao.png" alt="">
                                </div>
                                <div class="bottom">公交</div>
                            </div>
                            <div class="item">
                                <div class="top"><img src="./ditie.png" alt=""></div>
                                <div class="bottom">地铁</div>
                            </div>
                            <div class="item">
                                <div class="top"><img src="./chaoshi.png" alt=""></div>
                                <div class="bottom">超市</div>
                            </div>
                            <div class="item">
                                <div class="top"><img src="./canying.png" alt=""></div>
                                <div class="bottom">餐饮</div>
                            </div>
                            <div class="item">
                                <div class="top"><img src="./jiudian.png" alt=""></div>
                                <div class="bottom">酒店</div>
                            </div>
                            <div class="item">
                                <div class="top"><img src="./jinrong.png" alt=""></div>
                                <div class="bottom">金融</div>
                            </div>
                            <div class="item">
                                <div class="top"><img src="./zhuzhai.png" alt=""></div>
                                <div class="bottom">住宅</div>
                            </div>
                            <div class="item">
                                <div class="top"><img src="./wuliu.png" alt=""></div>
                                <div class="bottom">物流</div>
                            </div>
                        </div>
                    </div>
                     <div class="house-news">
                        <div class="title">
                            <div class="left">最新动态</div>
                             <div class="right" @click="entermore('dongtai')"><span>查看更多</span><van-icon name="arrow" /></div>
                        </div>
                        <div  class="photos">
                            <div class="item" :key="item.id" v-for="item in dynamic_info_list" @click="entermore('newsdetail',item)">
                               <div class="left">
                                   <img v-if="item.url" :src="item.url" alt="">
                               </div>
                               <div class="right">
                                    <div class="head">
                                       <div class="start">共渡难关</div>
                                       <div class="end">
                                           <div class="inner">{{item.title}} </div>
                                           </div>
                                    </div>
                                    <div class="content">
                                       {{item.description.substring(0,34)+'....'}}
                                    </div>
                               </div>
                            </div>
                        </div>
                    </div>
                    <div class="tuijian">
           <div class="top">
               <div class="title">
                        楼盘推荐
                </div>
                <div class="more" @click="entermore('tuijian')"><span>查看更多</span><van-icon name="arrow" /></div>
           </div>
           <div class="fang-wrap" @click="entermore('loupandetail',item)" :key="item.building_id" v-for="item in buildingPushList">
               <div class="left">
                   <img v-if="item.url" :src="item.url" alt="">
               </div>
               <div class="right">
                    <div class="status-wrap">
                        <div class="status">在租</div>
                        <div class="title">{{item.building_name}}</div>
                    </div>
                    <div class="p-location">
                        <!-- <span class="place">北京</span>
                        <span class="location">大兴区</span> -->
                        {{item.area_name}}
                    </div>
                    <div class="price">
                        <!-- <span class="big">2.3</span>
                        <span>元/平方米/天</span> -->
                        {{item.price_explain}}
                    </div>
                    <div class="btn-group">
                        <div class="item" :key="list.label" v-for="list in item.labels">
                            {{list.label}}
                        </div>
                    </div>
               </div>
           </div>
        </div>
                </div>
            </div>
        </div>
        <div class="share-tip" v-show="showTip" @click="showTip = false">
            <img src="../assets/images/share-tip.png" alt="">
        </div>
        <van-image-preview v-model="show" :images="images" @change="picChange">
            <template v-slot:index>
                {{showname}}{{ index }}/{{images.length}}

                </template>
        </van-image-preview>
        <Footer></Footer>
    </div>
</template>
<script>

    import Header from '@/components/Header'
    import wx from 'weixin-js-sdk'
    import Footer from '@/components/Footer'
    import { Swipe, SwipeItem,Icon,Toast,ImagePreview } from 'vant'
	import {mapState} from 'vuex'
    export default {
        name: "photosview",
        data: function(){
            return {
                developer:null,
                showname:'项目图',
                index:1,
                show:false,
                images:[],
                showview:false,
                roomdraw_list:[],
                downPath:'',
                efflen:'',
                reallen:'',
                building_house_list: [],
                showTip:false,
                tabIndex:1,
                mapKey:'',
                 mapInfo: {
                    center: {lng: 116.405419, lat: 39.915156},
                    zoom: 14,
                    radius: 1000,
                },
                companyInfo:{
                   

                },
                buildingPushList:[],
                dynamic_info_list:[],
                building_info:{
                   iscollect:0,
                   project_picture:[],
                   real_picture:[],
                   effect_picture:[],
                   main_img:'',
                   vr_url:'',
                   description:'',
                   merchants_call_400:'',
                   contact:'',
                   labels:[],
                   rent_sale_price:'',
                   address:'',
                   rent_sale_price_danwei:'',
                   building_name:'',
                   sales_status:'',
                   subway_steps:'',
                   development_co:'',
                   rent_sale_formal:''
               }, 
            }
        },
        components: {
            Header, Footer,
            [Icon.name]:Icon,
            [Swipe.name]: Swipe,
            [SwipeItem.name]: SwipeItem
        },
        created(){
            this.downPath = this.api.downPath;
            this.getView()
        },
        mounted(){
           
        },
		computed:{
			...mapState(['cityList'])
		},
        watch: {
        $route: {
            handler: function(val, oldVal){
                this.downPath = this.api.downPath;
                this.getView()
            },
            // 深度观察监听
            deep: true
        }
        },
        methods: {
            picChange(index){
                this.index = index+1;
            },
            shoview(val){
               
                let that=this
                switch(val){
                    case 'project_picture':
                       this.showname="项目图"
                        that.images=that.building_info[val].map(item=>{
                    return that.downPath+item
                })
                        break;
                    case 'effect_picture':
                         this.showname='效果图'
                          that.images=that.building_info[val].map(item=>{
                    return that.downPath+item
                })
                        break;
                    case 'real_picture':
                         this.showname='实景图'
                          that.images=that.building_info[val].map(item=>{
                    return that.downPath+item
                })
                        break;
                    case 'huxing':
                        //roomdraw_list
                         that.images=that.roomdraw_list.map(item=>{
                    return that.downPath+item.draw_url
                })
                        this.showname='户型图'
                        break;
                }
               
                that.show=true
            },
            keepHouse(){
                const _this = this;
                let params = new FormData();
                params.append('id', _this.$route.query.id);
                params.append('type', 'building');
                _this.api.addCollection(params).then(function(response){
                    Toast(response.msg);
                    _this.getView();
                })
            },
            addFocus(){
                const that = this;
                let params = new FormData();
                params.append('member_id', that.companyInfo.member_id);
                that.api.addFocus(params).then(function(response){
                    Toast(response.msg);
                    that.getView();
                })
            },
            delFocus(){
                const that = this;
                let params = new FormData();
                params.append('focus_id', that.companyInfo.focus_id);
                that.api.delFocus(params).then(function(response){
                    Toast(response.msg);
                    that.getView();
                })
            },
            morehu(){
                this.$router.push({
                    path: '/alltype'
                })
            },
            entermore(val,item){
                switch(val){
                    case 'fangyuan':
                        this.$router.push({
                            path: '/HouseList'
                        })
                    break;
                    case 'tuijian':
                        this.$router.push({
                            path: '/PropertyList'
                        })
                    break;
                    case 'dongtai':
                        this.$router.push({
                            path: '/NewsList'
                        })
                    break;
                    case 'loupandetail':
                        this.$router.push({
                            path: '/Property',
                            query: {
                                id: item.building_id
                            }
                        })
                    break;
                     case 'house':
					
                        this.$router.push({
                            path: '/house',
                            query: {
                                id: item.house_id
                            }
                        })
                    break;
                    case 'newsdetail':
                        this.$router.push({
                            path: '/detailInfoView',
                            query: {
                                id: item.info_id
                            }
                        })
                    break;
                }
            },
            markActive(e){
                switch(e){
                    case 1:
                        this.tabIndex=e
                    break;
                    case 2:
                        if(this.building_info.effect_picture.length>0){
                            this.tabIndex=e
                        }else{
                            Toast('无数据');
                        }
                        
                        break;
                    case 3:
                        if(this.building_info.real_picture.length>0){
                            this.tabIndex=e
                        }else{
                          Toast('无数据');  
                        }
                        break;
                }
            },
            entervr(){
                window.location.href=this.building_info.vr_url
            },
            housedesc(){
                this.$router.push({
                    path: '/housedesc',
                    query: {
                        id: this.$route.query.id
                    }
                })
            },
            getShareConfig(){

                const that = this;
                that.api.getShareConfig({
                    url: window.location.href.split('#')[0],
                    target: 'Property',
                    id: that.$route.query.id
                }).then(function(response){
                    const result = response;
                    wx.config({
                        debug: false,
                        appId: result.appId,
                        timestamp: result.timestamp,
                        nonceStr: result.nonceStr,
                        signature: result.signature,
                        jsApiList: [
                            'updateAppMessageShareData',
                            'updateTimelineShareData'
                        ]
                    });
                    wx.error(function (res) {
                        console.log('验证失败返回的信息:',res.errMsg);
                    });
                    var link = '';
                    var u = navigator.userAgent, app = navigator.appVersion;
                    var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; //g
                    var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
                    if (isAndroid) {
                        link = window.location.href.split('#')[0] + '?#' + window.location.href.split('#')[1]
                    }
                    if (isIOS) {
                        link = window.location.href.split('#')[0] + '#' + window.location.href.split('#')[1]
                    }
                    wx.ready(function () {
                        const imgUrl = that.downPath + that.building_info.project_picture[0];
                        // 分享给朋友
                        wx.updateAppMessageShareData({
                            title: that.building_info.building_name+'-选址中国', // 分享标题
                            desc: that.building_info.description, // 分享描述
                            link: link,
                            imgUrl: imgUrl, // 分享图标
                            success: function () {}
                        });

                        // 分享到朋友圈
                        wx.updateTimelineShareData({
                            title: that.building_info.building_name+'-选址中国', // 分享标题
                            desc: that.building_info.description, // 分享描述
                            link: link,
                            imgUrl,
                            success: function () {}
                        });
                    });
                })
            },
           getView(){
                
                const that = this;
                let id=that.$route.query.id
                that.api.getHouseDesc({building_id:that.$route.query.id}).then(function(e){
					console.log(that.cityList,'???????????????????????')
					//cityList
					
					//building_info.city_id
                    that.getShareConfig();
                    that.roomdraw_list=e.roomdraw_list
                   let building_info=e.building_info
				   let city=that.cityList.filter(item=>{
				   	return item.id===building_info.city_id
				   })
				   
				   that.$store.commit('setActiveAddr', city[0].name);
				   
				   that.$store.commit('changeActiveAddr', city[0]);
				  // that.activeCity = _this.$store.getters.activeAddr.name;
				   
				  
				   
				   
                   that.developer=e.developer
                   if(e.building_info.effect_picture==null){
                       e.building_info.effect_picture=[]
                   }
                    if(e.building_info.real_picture==null){
                       e.building_info.real_picture=[]
                   }
                   that.efflen=e.building_info.effect_picture.length
                    that.reallen=e.building_info.real_picture.length
                   that.companyInfo=e.companyInfo
                   that.buildingPushList=e.buildingPushList.map(item=>{
                       item.url=that.downPath+""+item.main_img
                       return item
                   })
                   that.building_house_list=e.building_house_list.map(item=>{
                       item.url=that.downPath+(item.main_img.replace(/\\/g,'').replace(/\"/g,''))
                       let index=item.rent_sale_price.indexOf('元')
                       item.price=item.rent_sale_price.substring(0,index)
                       return item
                   })
                   building_info.main_img=that.downPath+building_info.main_img.replace(/\\/g,'').replace(/\"/g,'')
                   that.dynamic_info_list=e.dynamic_info_list.map(item=>{
                       item.url=that.downPath+"/"+item.thumbnail
                       return item
                   })
                   for(let item in that.building_info){
                       that.building_info[item]=building_info[item]
                   }
                    setTimeout(function(){
                        that.mapInfo.center.lng = e.building_info.longitude;
                        that.mapInfo.center.lat = e.building_info.latitude
                    }, 100)

                })
            }
        }
    }
</script>
<style scoped lang="scss">
@import "./common.scss";
.fanyuan-wrap .top .big{
    padding-right:px2rem(5px);
    font-weight:bold;
    font-size:px2rem(14px);
    color:#FE0000;
}
.fanyuan-wrap .top .status{
    color:#fff;
    background:#FE0000;
    font-size:px2rem(8px);
    padding:px2rem(1px) px2rem(3px);
    border-radius:px2rem(1px);
}
.fanyuan-wrap .top{
    height:px2rem(28px);
    color:#888;
}
.fanyuan-wrap .center{
    height:px2rem(20px);
    color:#888;
}
.fanyuan-wrap{
    margin-top:px2rem(10px);
    display:flex;
}
.fanyuan-wrap .left-img{
    margin-right:px2rem(10px);
    width:px2rem(110px);
    height:px2rem(64px);
    border-radius:px2rem(5px);
}
.fanyuan-wrap .left-img img{
    border-radius:px2rem(5px);
    width:px2rem(110px);
    height:px2rem(68px);
}
.pro-hd-pic-1 img{
    height:100%;
    width:100%;
}
.pro-hd-pic-1{
    height:100%;
}
    .house-news{
        padding-bottom: px2rem(8px);
    }
    .house-news .photos .content{
        padding-left:px2rem(3px);
    }
     .house-news .photos .end{
         position:relative;
           height:px2rem(22px);
           display:flex;
           align-items: center;
       flex:1;
    }
    .house-news .photos .inner{
        width:100%;
        position:absolute;
        white-space:nowrap; 
        overflow: hidden;
        text-overflow: ellipsis;
        font-size:px2rem(10px);
    }
    .house-news .photos .head{
        padding-left:px2rem(3px);
        align-items: center;
        display:flex;
        flex:1;
    }
    .house-news .photos .start{
        height:px2rem(22px);
        display:flex;
        align-items: center;
       width:px2rem(48px)
    }
    .house-news .photos .title{
       font-size:px2rem(10px);
    }
    .house-news .photos .content{
       font-size:px2rem(8.33px);
       color:#828282;
    }
    .house-news .photos .item{
        align-items: center;
       display:flex;
       margin-bottom:px2rem(4px)
    }
    .house-news .photos .right{
        padding-left:px2rem(3px);
       flex:1;
    }
    .house-news .photos .left{
        width:px2rem(72px);
        height:px2rem(58px);
    }
     .house-news .photos .left img{
       height:100%;
       width:100%;
       display:block;
    }
    .house-news .title .right{
        font-size:px2rem(10px);
        display:flex;
        align-items: center;
        color:#95999c;
    }
    .house-news .title .left{
        font-size:px2rem(15.38px);
    }
    
    .house-news .title{
        padding:px2rem(10px) 0;
        display:flex;
        justify-content: space-between;
    }
    .traffic-wrap .item{
        font-size:px2rem(9.39px);
        text-align: center;
    }
    .big-phone{
        font-weight:bold;
        font-size:px2rem(10.65px)
    }
    .traffic-wrap .top{
        margin:0 auto;
        height:px2rem(19.63px);
        border-radius:50%;
        width:px2rem(19.63px);
    }
    .traffic-wrap .top img{
        display: block;
        height:100%;
        width:100%;
    }
    .traffic-wrap .photos{
        padding-top:px2rem(9px);
        display:flex;
        justify-content: space-around;
    }
    #map{
        height:px2rem(178px);
        background:red;
    }
    .traffic-wrap{
        padding:px2rem(0px) 0 px2rem(10px) 0;
    }
    .traffic-wrap .title{
        padding:px2rem(10px) 0 px2rem(10px) 0;
        display:flex;
        font-size:px2rem(15.38px)
    }
    .select-content .top{
        background:#eaf7f4;
        color:#7cc2b2;
        width:px2rem(41.67px);
    }
    .select-content .center{
        color:#e9ba60;
        margin:px2rem(1px) 0;
         width:px2rem(41.67px);
        background:#f7f2e9;
    }
    .select-content .bottom{
        width:px2rem(41.67px);
        color:#809ab9;
        background:#edf3f8;
    }

    .select-content .item{
        font-size:px2rem(6.77px);
        margin:0 auto;
    }
    .select-content .gray{
        font-size:px2rem(6.78px);
        color:#888;
    }
    .select-content .key{
        text-align: center;
        flex:1;
    }
    .select-wrap .key{
        text-align: center;
        flex:1;
    }
    .select-content .status{
        text-align: center;
        flex:1;
    }
    .select-wrap .status{
        text-align: center;
        flex:1;
    }
    .select-content .price{
        display:flex;
        align-items: baseline;
        text-align: center;
        flex:1;
    }
    .select-wrap .price{
        text-align: center;
        flex:1;
    }

   .select-content .area{
        text-align: center;
        display:flex;
        align-items: baseline;
        flex:1;
    }
    .select-wrap .area{
        text-align: center;
        flex:1;
    }
    .select-content .img-wrap{
        margin-bottom:px2rem(6px);
        width:px2rem(77.67px);
        margin-right:px2rem(6.33px);
        height:px2rem(59.33px);
    }
    .select-content .img-wrap img{
       height:100%;
       width:100%;
    }
    .select-wrap .all{
        width:px2rem(77.67px);
        margin-right:px2rem(6.33px);
    }
    .select-content{
        font-size:px2rem(7.66px);
        align-items: center;
        justify-content: space-around;
        display:flex;
    }
    .select-wrap{
        font-size:px2rem(8.66px);
        display:flex;
        padding:px2rem(15px) 0 px2rem(14px) 0;
        justify-content: space-around;
    }
    .house-source .title .left{
        font-size:px2rem(15.38px);
    }
    .house-source .title .right{
        display:flex;
        align-items: center;
        color:#94989b;
        position:relative;
        font-size:px2rem(10px);
        
    }
    .house-source{
      padding-top:px2rem(22px);  
    }
    .house-source .title{
        display:flex;
        padding:0 px2rem(0px);
        justify-content: space-between;
    }
    .house-type .inner img{
        margin:0 auto;
       width:px2rem(68.67px);
       height:100%;
       display:block;
    }
    .house-type .in-status{
        background:#ff0000;
        color:#fff;
        width:px2rem(25px);
        height:px2rem(12.33px);
        align-items: center;
        display:flex;
        margin-top:px2rem(2px);
        justify-content: center;
        font-size:px2rem(8.42px); 
    }
    .house-type .in-subtitle{
        color:#888d90;
        font-size:px2rem(7.61px);
    }
    .house-type .inner{
        border:px2rem(1px) solid #e6e6e6;
        padding:0 px2rem(6px);
        height:px2rem(104.33px);
        width:px2rem(104px);
    }
    .house-type .photos{
        display:flex;
        white-space: nowrap;
        width:100%;
        overflow-x: auto;
        padding-bottom:px2rem(10px)
    }
    .house-type .in-title{
        font-size:px2rem(10.05px);
        margin:px2rem(3px) 0;
    }
    .house-type .photos .item{
        margin:0 px2rem(12px);
        width:39%;
        display: inline-block;
    }
    .house-type{
        padding:0 px2rem(0px);
    }
    .house-type .title .right{
        font-size:px2rem(10px);
        display:flex;
        align-items: center;
        color:#95999c;
        position:relative;
        top:px2rem(10px);
    }
    .house-type .title .left{
        font-size:px2rem(15.38px);
        color:#1E1E1E;
        margin-top:px2rem(20px);
    }
    .house-type .title{
       display:flex;
       justify-content: space-between;
       padding-bottom:px2rem(12px);
    }
    .house-wrap .content{
        width: 100%; 
          overflow: hidden; 
          display: -webkit-box; 
		  max-height:7em;
          -webkit-line-clamp: 4; 
          -webkit-box-orient: vertical; 
        font-size:px2rem(10px);
        padding-top:px2rem(10px);
        margin-bottom:px2rem(16px);
    }
    .house-wrap .title .right{
        color:#95999C;
        display:flex;
        align-items: center;
        position:relative;
        top:px2rem(10px);
        font-size:px2rem(10px);
    }
    .house-wrap .title .left{
        font-size:px2rem(15.38px);
        color:#1E1E1E;
        margin-top:px2rem(20px);
    }
    .house-wrap .title{
        display:flex;
        align-items: center;
        justify-content: space-between;
    }
    .house-wrap{
        padding:0 px2rem(0px);
    }
     .user-wrap .company_name{
        width:100%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        font-size:px2rem(6.82px);
     }
    .user-wrap .name{
        font-size:px2rem(8.86px);
        padding-right:px2rem(4px);
        font-weight:bold;
    }
     .user-wrap .job{
        font-size:px2rem(6.81px);
        
    }
    .user-wrap .introduence{
        background:url(./guanzhup.png)#d30000 no-repeat px2rem(7px) center;
        background-size:px2rem(8px) auto;
        color:#fff;
        font-size:px2rem(7.3px);
        margin-top:px2rem(3px);
        padding-left:px2rem(20px);
        width:px2rem(44px);
    }
   .user-wrap .inner-right{
       width:px2rem(90px);
        padding-left:px2rem(4px);
        padding-right:px2rem(4px);
    }
    .user-wrap .right{
        font-size:px2rem(8px);
        display:flex;
        align-items: center;
        justify-content: space-between;
    }
    .user-wrap .inner-left{
        border-radius:50%;
        width:px2rem(44.67px);
        height:px2rem(44.67px);
    }
    .user-wrap .inner-left img{
        height:100%;
        border-radius:50%;
        width:100%;
        display:block;
    }
    .user-wrap .left{
        font-size:px2rem(9.61px);
        padding:px2rem(18px) px2rem(0px) px2rem(6px) px2rem(10px);
    }
    .user-wrap{
        background:#efd6af;
        padding:px2rem(4px) 0;
        display:flex;
        justify-content: space-between;
        margin-top:px2rem(40px);
    }
    .clicks-btn .show{
        background:url(./view.png) no-repeat px2rem(7px) center;
        background-size:px2rem(9px) auto;
        padding-right:px2rem(12px);
        padding-left:px2rem(20px);
        position:relative;
    }
     .clicks-btn .share{
        background:url(./share.png) no-repeat px2rem(7px) center;
        background-size:px2rem(9px) auto;
        padding-right:px2rem(12px);
        padding-left:px2rem(20px);
        position:relative;
    }
    .clicks-btn .share:after{
        display:block;
        content:'';
        position:absolute;
        height:px2rem(10px);
        background:#2f6095;
        width:px2rem(1px);
        right:0;
        top:px2rem(3px);
        
    }
    .clicks-btn .store{
        background:url(./store.png) no-repeat px2rem(7px) center;
        background-size:px2rem(9px) auto;
        padding-right:px2rem(12px);
        padding-left:px2rem(20px);
        position:relative;
    }
    .clicks-btn .store:after{
        display:block;
        content:'';
        position:absolute;
        height:px2rem(10px);
        background:#2f6095;
        width:px2rem(1px);
        right:0;
        top:px2rem(3px);
        
    }
    .clicks-btn .view:after{
       
        display:block;
        content:'';
        position:absolute;
        height:px2rem(10px);
        background:#2f6095;
        width:px2rem(1px);
        right:0;
        top:px2rem(3px);
        
    }
    .clicks-btn .view{
        padding-left:px2rem(20px);
        background:url(./guanzhu.png) no-repeat px2rem(7px) center;
        background-size:px2rem(9px) auto;
        padding-right:px2rem(12px);
        position:relative;
    }
    .clicks-btn{
        padding:0 px2rem(13px);
        background:#fff;
    }
    .clicks-btn .inner{
        padding:px2rem(10px) 0;
        border-top:px2rem(1px) solid #ecedee;
        background:#fff;
        justify-content: center;
        color:#2f6095;
        font-size:px2rem(10.29px);
        
        display:flex;
        align-items: center;
    }
     .more-btn .inner{
        height:px2rem(31px);
        background:#f6f6f6;
        display:flex;
        color:#e2b267;
        justify-content: center;
        align-items: center;
        font-size:px2rem(11.46px);
    }
    .more-btn{
        padding:px2rem(10px) px2rem(13px);
        background:#fff;
    }
    .itemdesc-wrap .big{
        color:#ff0000;
        padding-right:px2rem(5px);
        font-size:px2rem(17.22px);
    }
    .itemdesc-wrap .danwei{
         font-size:px2rem(7.88px);
    }
    .itemdesc-wrap .price-wrap{
        display:flex;
        align-items: center;
        margin-bottom:px2rem(8px)
    }
    .itemdesc-wrap .price{
        font-size:px2rem(12.66px)!important;
        
        width:px2rem(63px)!important;
    }
    .itemdesc-wrap li{
        display:flex;
    }
     .itemdesc-wrap .label{
        font-size:px2rem(10.05px);
        display:flex;
        width:20%;
        color:#7e8386;
    }
     .itemdesc-wrap .content{
        font-size:px2rem(10.05px);
        display:flex;
        align-items: baseline ;
        width:72%;
        color:#1e1e1e;
    }
    .itemdesc-wrap{
        background:#fff;
        padding:px2rem(14px) px2rem(13px);
    }
        .btns-wrap{
            padding:px2rem(6px) 0 px2rem(6px) 0;
            background:#fff;
            margin:0 px2rem(13px) 0 px2rem(13px);
            border-bottom:px2rem(1px) solid #f4f5f5;
        }
     .shuzimeiti{
        font-size:px2rem(8.21px);
        display:flex;
        padding:0 px2rem(5px);
        justify-content: center;
        margin-left:px2rem(3px);
        align-items: center;
        color:#fff;
        height:px2rem(16px);
        background:#6da2eb;
    }
    .high-jishu{
        display:flex;
        padding:0 px2rem(5px);
        justify-content: center;
        margin-left:px2rem(3px);
        align-items: center;
        color:#fff;
        height:px2rem(16px);
        background:#f3806b;
    }
    .new-n{
        display:flex;
        padding:0 px2rem(5px);
        justify-content: center;
        align-items: center;
        color:#fff;
        font-size:px2rem(8.21px);
        height:px2rem(16px);
        background:#ff8487;
    }
    .zhineng{
        font-size:px2rem(8.21px);
        display:flex;
        margin-left:px2rem(3px);
        padding:0 px2rem(5px);
        justify-content: center;
        align-items: center;
        color:#fff;
        height:px2rem(16px);
        background:#4cb41f;
    }
    .new-n{
       
        justify-content: center;
        align-items: center;
        color:#fff;
       
        background:#ff8487;
    }
    .btns-wrap{
        display:flex;
    }
    .h-title{
        background:#fff;
        display:flex;
        align-items: center;
        padding-left:px2rem(13px);
        padding-right:px2rem(13px);
        padding-top:px2rem(12px);
    }
    .h-title .status{
        margin-left:px2rem(6px);
        height:px2rem(16px);
        color:#fff;
        width:px2rem(32.67px);
        color:#fff;
        background:#ff0000;
        font-size:px2rem(10.75px);
        display:flex;
        justify-content: center;
        align-items: center;
        border-radius:px2rem(2px);
    }
    h1{
        font-weight:bold;
        font-size:px2rem(19.15px);

    }
    .btn-groups{
        position:relative;
        display:flex;
        justify-content: center;
        margin-bottom:px2rem(10px);
    }
    .btn-groups .total{
        background:rgba(0,0,0,.77);
        width:px2rem(40px);
        color:#fff;
        height:px2rem(16px);
        display:flex;
        font-size:px2rem(8px);
        justify-content: center;
        align-items: center;
        border-radius:px2rem(10px);
        position:absolute;
        right:0;
    }
    .btn-groups .item{
        font-size:px2rem(8.46px);
        background:rgba(255,255,255,.87);
        margin-right:px2rem(6px);
        width:px2rem(39.33px);
        height:px2rem(17.33px);
        display:flex;
        justify-content: center;
        align-items: center;
        border-radius:px2rem(8px);
    }
    .btn-groups .active{
        color:#fff!important;
        background:#3cb850!important;
    }
    .wrap{
        background:#fafafa;
    }
   .p-card{
       position:relative;
       height:px2rem(200px);
   }
   .p-card .main-img{
       height:100%;
       width:100%;
   }
   .vr-p{
       background:rgba(0,0,0,0.5);
       position:absolute;
       margin-top:px2rem(-20px);
       margin-left:px2rem(-20px);
       left:50%;
       top:50%;
       z-index:100;
       width:px2rem(40px);
       height:px2rem(40px);
       border-radius:50%;
   }
   .vr-p img{
       height:100%;
       width:100%;
   }
   .inner-wrap{
       position:relative;
       margin-top:px2rem(-20px);
       padding:0 px2rem(9px);
   }
   .main-content{
       margin-top:px2rem(-40px)
   }
   .fang-wrap .p-location{
        height:px2rem(14px);
        display:flex;
        align-items: center;
        font-size:px2rem(9px)
    }
   .fang-wrap .price{
       padding:px2rem(3px);
       font-size:px2rem(7.5px);
        color:#ff0100;
    }
    .fang-wrap .big{
        font-size:px2rem(15px);
        font-weight:bold;
    }
    .fang-wrap .btn-group{
        display:flex;
        align-items: center;
    }
     .fang-wrap .btn-group .item{
       color:#336094;
       border:px2rem(1px) solid #336094;
        margin-right:px2rem(4px);
        height:px2rem(13px);
        display:flex;
        align-items: center;
        padding:0 px2rem(5px);
        font-size:px2rem(7.64px)
    }
     .fang-wrap .place{
        margin-right:px2rem(6px);
    }
    .fang-wrap .status-wrap{
        display:flex;
        align-items: center;
    }
    .fang-wrap .title{
       font-size:px2rem(10px)!important;
        font-weight:bold;
    }
    .fang-wrap .status{
        background:#fe0000;
        height:px2rem(13px);
        margin-right:px2rem(4px);
        display:flex;
        justify-content: center;
        align-items: center;
        width:px2rem(26.67px);
        font-size:px2rem(8.37px);
        color:#fff;
    }
    .fang-wrap{
        display:flex;
        margin-bottom:px2rem(8px);
    }
    .fang-wrap .left{
        margin-top:px2rem(1.8px);
        margin-right:px2rem(10.67px);
        width:px2rem(104px);
        height:px2rem(77.67px);
        border-radius:px2rem(3px);
    }
    .fang-wrap .left img{
        width:100%;
        height:100%;
    }
    .tuijian .title{
        font-size:px2rem(15.38px);
    }
    .tuijian .more{
        color:#9a9da1;
        font-size:px2rem(10px);
        display:flex;
        align-items: center;
    }
    .tuijian .top{
        display:flex;
        padding-bottom:px2rem(14px);
        justify-content: space-between;
    }
    .tuijian{
        margin-top:px2rem(10px);
    }
</style>